import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import useStyles from './ComponentStyled.style';
export type MarginType = '0' | '8' | '16' | '24' | '32';
export interface ComponentStyledBaseProps {
 marginBottom?: MarginType;
 marginTop?: MarginType;
}
export type ComponentStyledProps<T extends ElementType> =
 ComponentStyledBaseProps & {
   component: T;
   componentProps?: ComponentPropsWithoutRef<T>;
 };
export const ComponentStyled = <T extends ElementType = 'div'>({
 marginBottom,
 marginTop,
 component: Component,
 componentProps,
}: ComponentStyledProps<T>) => {
 const c = useStyles({ marginBottom, marginTop });
 return (
   // @ts-expect-error LibraryManagedAttributes
   <Component
     {...(componentProps)}
     className={c.root}
   />
 );
};
